var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.959 4.12719C10.959 5.95173 9.50787 7.40858 7.74498 7.40858C5.98208 7.40858 4.53092 5.95173 4.53092 4.12719C4.53092 2.30265 5.98208 0.845801 7.74498 0.845801C9.50787 0.845801 10.959 2.30265 10.959 4.12719Z",
    stroke: "#FF0990",
    strokeWidth: 1.55
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74609 16.3169C5.77232 16.3169 3.86158 14.8505 2.4339 12.87C2.01883 12.2942 1.97756 11.6848 2.16526 11.2082C2.35214 10.7337 2.79122 10.3255 3.48293 10.2004C4.55135 10.0071 5.95513 9.8584 7.74609 9.8584C9.53706 9.8584 10.9408 10.0071 12.0093 10.2004C12.701 10.3255 13.14 10.7337 13.3269 11.2082C13.5146 11.6848 13.4734 12.2942 13.0583 12.87C11.6306 14.8505 9.71987 16.3169 7.74609 16.3169Z",
    stroke: "#FF0990",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.ab443bd2.svg";
export { ForwardRef as ReactComponent };